import React, { useEffect, useState } from "react";
import API from "../../../api";
import { uniqueId } from "lodash";

// redux
import { mapDispatchProps, mapStateToProps } from "../../../store/store";
import { connect } from "react-redux";
import useInfiniteScroll from "../../../hooks/useInfiniteScroll";
import SnsPaymentHistoryItem from "../../../components/snsPaymentHistoryItem/index";
import { useLanguage } from '@languages/index';

const SNSPaymentIndex = (props: any) => {
  const language = useLanguage();   
  const languageTexts = { ...language.common, ...language.pages.sns };
  const [histories, setHistories] = useState([]);
  const [historiesCnt, setHistoriesCnt] = useState(0);

  const [schedule, setSchedule] = useState(undefined);
  const [isFetchFinished, setIsFetchFinished] = useState(false);
  const [isContentEnded, setIsContentEnded] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  const [isFetching, setIsFetching] = useInfiniteScroll(() => {
    if (histories.length) {
      fetchPaymentHistories();
    }
  });

  useEffect(() => {
    if (!histories.length && !isContentEnded) {
      fetchPaymentHistories(true);
    }
  }, [histories]);

  const fetchPaymentHistories = (refresh = false) => {
    if (isContentEnded && !refresh) {
      return false;
    }

    const targetPage = refresh ? 1 : currentPage;

    API.SnsPayments.index({
      ...{
        brandToken: props.auth.token,
        page: targetPage,
      },
    })
      .then((response) => {
        const fetchedHistories = response.data.histories.data;

        setHistories(
          targetPage === 1
            ? fetchedHistories
            : histories.concat(fetchedHistories)
        );

        setHistoriesCnt(response.data.count);
        setSchedule(response.data.schedule);

        setCurrentPage(targetPage + 1);
        setIsFetchFinished(true);

        if (
          response.data.histories.currentPage ==
          response.data.histories.lastPage
        ) {
          setIsContentEnded(true);
        }

        setIsFetching(false);
      })
      .catch((error) => {
        props.showModal({ text: error.message });
      });
  };

  const renderPageTitle = () => {
    return (
      <div className="flex flex-row justify-between mb-2 lg:mb-9">
        <span className="font-bold text-xl tracking-tighter">{languageTexts.payment_history2}</span>
      </div>
    );
  };

  const renderHistories = () => {
    if (isFetchFinished && histories.length == 0) {
      return (
        <div className="py-10 flex flex-col justify-center w-full items-center">
          <div className="mx-5 flex">
            <span className="prose prose-xl text-slate-500">
              {languageTexts.payments_index_text_1}
            </span>
          </div>
        </div>
      );
    }

    return (
      <div className="flex flex-col py-10">
        <div className="flex flex-row py-2 px-5 bg-black justify-around font-bold text-white gap-3">
          <span className="w-[80px] text-start text-sm font-bold">
            {languageTexts.payments_index_text_2}
          </span>
          <span className="flex-1 text-right text-sm font-bold">{languageTexts.payment_info}</span>
        </div>

        {histories.map((history) => {
          return (
            <SnsPaymentHistoryItem
              key={`sns-payment-${uniqueId()}`}
              history={history}
            />
          );
        })}
      </div>
    );
  };

  return (
    <>
      <div className="px-5 py-6 xl:px-10 pb-10 mx-auto w-full max-w-[800px] mb-[48px]">
        {renderPageTitle()}
        {renderHistories()}
      </div>
    </>
  );
};

export default connect(mapStateToProps, mapDispatchProps)(SNSPaymentIndex);
